import { useState } from 'react'
import { Trans, useTranslation } from 'react-i18next'

import { Styles as S } from '~/pages/anatomy/strongestMuscle/styles'
import { useDelayedContinue } from '~/shared/hooks/useDelayedContinue'
import { useNextStep } from '~/shared/hooks/useNextStep'
import { TPageProps } from '~/shared/types/commonTypes'

interface IGridOption {
  key: string
  i18nKey: string
  png: string
  webp: string
}

interface IGridChoiceProps extends TPageProps {
  options: IGridOption[]
  questionKey: string
  question: string
  answersAtBottom?: boolean
}

const GridChoice = ({
  nextPagePath,
  pageId,
  options,
  questionKey,
  question,
  answersAtBottom,
}: IGridChoiceProps) => {
  const { t } = useTranslation('anatomy')
  const [answer, setAnswer] = useState('')

  const handleContinue = useNextStep({
    nextPagePath,
    pageId,
    pageName: pageId,
    question,
  })

  const { handleChange, isAnswersDisabled } = useDelayedContinue()

  const handleSelect = (key: string) => {
    setAnswer(key)
    handleChange(key, handleContinue)
  }

  return (
    <S.Root>
      <S.StyledContainer>
        <S.Question>
          <Trans t={t} i18nKey={questionKey} />
        </S.Question>

        <S.Grid $answersAtBottom={answersAtBottom}>
          {options.map(({ key, i18nKey, png, webp }) => (
            <S.OptionCard
              key={key}
              type="button"
              $isSelected={answer === key}
              onClick={() => handleSelect(key)}
              disabled={isAnswersDisabled}
            >
              <S.CardImage>
                <picture>
                  <source srcSet={webp} type="image/webp" />
                  <img src={png} alt={t(i18nKey)} />
                </picture>
              </S.CardImage>

              <S.CardLabel>{t(i18nKey)}</S.CardLabel>
            </S.OptionCard>
          ))}
        </S.Grid>
      </S.StyledContainer>
    </S.Root>
  )
}

export default GridChoice
